import { getApi } from "./api_instance";

export const getSellerTransactionCommunication = async (transactionId, dispatch) => {
  try {
    return await getApi({
      apiUrl: `/payments/api/transactions/communication/seller/${transactionId}`,
      dispatch,
      sendToken: true,
    });
  } catch (error) {
    throw error;
  }
}